import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { post } from "@insite/client-framework/Services/ApiService";
import { GetProductCollectionApiV2Parameter, ProductExpandTokens } from "@insite/client-framework/Services/ProductServiceV2";
import { DisplayProductsResult } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { Handler } from "@preferredMedical/HandlerCreator";
import { ProductPromotionModel } from "@preferredMedical/Store/Pages/ProductPromotions/ProductPromotionsState";

interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
}

interface Props {
    apiParameter: GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
}

type HandlerType = Handler<Parameter, Props>;

export const LoadProductPromotions: HandlerType = async props => {
    if (props.result.products?.length) {
        const productsPromotionRequest: ProductPromotionRequest[] = [];
        props.result.products.forEach(product => {
            if (product.brand?.id !== undefined) {
                productsPromotionRequest.push({
                    productId: product.id,
                    brandId: product.brand.id,
                });
            } else {
                productsPromotionRequest.push({
                    productId: product.id,
                    brandId: "",
                });
            }
        });

        type ProductPromotionRequest = {
            productId: string;
            brandId: string;
        };

        type ProductPromotionsResponse = {
            [key: string]: ProductPromotionModel[];
        };

        type Request = {
            productsPromotionRequest: ProductPromotionRequest[];
        };

        const productPromotionsResponse = await post<Request, ProductPromotionsResponse>(
            `api/v1/Promotions/GetProductPromotions`,
            {
                productsPromotionRequest,
            },
        );

        props.dispatch({
            type: "Custom/Pages/ProductPromotions/SetProductPromotions",
            productPromotions: productPromotionsResponse,
        });
    }
};